import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import Service from '@ember/service';

const VALID_SKELETONS = new Set([
  'availability',
  'clinician-search',
  'clinicians',
  'information',
  'locations',
  'prescreener',
  'services',
]);
const FALLBACK_SKELETON = 'information';
const STEP_TO_SKELETON = {
  clinician: 'clinicians',
  service: 'services',
  location: 'locations',
  date: 'availability',
  'information.index': 'information',
};
const TITLE_PREFIX = 'booking.steps.loading.';

export default class RequestPreloaderService extends Service {
  componentNameForStep(step) {
    if (typeof step !== 'string' || !step) {
      return FALLBACK_SKELETON;
    }

    let raw = step.startsWith(TITLE_PREFIX)
      ? step.slice(TITLE_PREFIX.length)
      : (STEP_TO_SKELETON[step] ?? step);

    return VALID_SKELETONS.has(raw) ? raw : FALLBACK_SKELETON;
  }

  componentForStep(step, context) {
    let name = this.componentNameForStep(step);
    let module = importSync(`../components/request/steps/loading/loading-${name}`);
    return ensureSafeComponent(module.default, context);
  }
}
